




















import Vue, { PropType } from 'vue';
import { Documents } from '@/types';
import MyDocumentsListItem from './MyDocumentsListItem.vue';
import { EventType } from '@/constants';

export default Vue.extend({
  name: 'MyDocumentsList',
  components: {
    MyDocumentsListItem
  },
  data () {
    return {
      documents: [] as Documents[]
    };
  },
  props: {
    isInactivejob: {
      type: Boolean,
      default: false
    },
    sortedDocuments: {
      type: Array as PropType<Documents[]>,
      required: true
    },
    divisionId: {
      type: String,
      required: true
    }
  },
  mounted () {
    this.documents = this.sortedDocuments;
  },
  watch: {
    sortedDocuments () {
      this.documents = this.sortedDocuments;
    }
  },
  methods: {
    showNotificationModal (data: any) {
      this.$emit(EventType.SHOW_NOTIFICATION_MODAL, data);
    }
  }
});
